import { render, staticRenderFns } from "./DeleteFooterButton.vue?vue&type=template&id=07bcb198&scoped=true&"
import script from "./DeleteFooterButton.vue?vue&type=script&lang=ts&"
export * from "./DeleteFooterButton.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteFooterButton.vue?vue&type=style&index=0&id=07bcb198&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bcb198",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
